/* 2026-10-29 NJ QA: editorial complementarios sincronizados con Shopify; comprobar stock mediante producto.js. */
/* V14.14: asociaciones compatibles verificadas con fichas activas Shopify.
   Una sola fuente para las recomendaciones de ficha y carrito. */
window.NJProductPairs = Object.freeze({
  "qiqi-smooth-service-champu-300ml": [
    "qiqi-hydration-fixation-conditioner-300g",
    "qiqi-super-soaker-mascarilla-250g"
  ],
  "qiqi-hydration-fixation-conditioner-300g": [
    "qiqi-smooth-service-champu-300ml",
    "qiqi-super-soaker-mascarilla-250g"
  ],
  "davines-oi-shampoo-280ml": [
    "davines-oi-conditioner-250ml",
    "oi-hair-butter-250-ml-davines"
  ],
  "davines-oi-conditioner-250ml": [
    "davines-oi-shampoo-280ml",
    "oi-hair-butter-250-ml-davines"
  ],
  "davines-champu-love-smoothing-250-ml": [
    "davines-love-smoothing-conditioner-250-ml",
    "davines-love-instant-mask-disciplinante-250ml"
  ],
  "davines-love-smoothing-shampoo-250ml-refill-500ml-pack": [
    "davines-love-smoothing-conditioner-250-ml",
    "davines-love-smoothing-lightweight-milk-150ml-anti-frizz"
  ],
  "davines-energizing-superactive-anytime": [
    "davines-250ml-anticaida-energizing-champu"
  ],
  "oribe-gold-lust-repair-and-restore-shampoo-250ml": [
    "oribe-gold-lust-repair-and-restore-conditioner-200ml",
    "oribe-gold-lust-transformative-masque-150-ml"
  ],
  "crema-reafirmante-natura-bisse-pro-exo-colageno-75ml": [
    "natura-bisse-essential-shock-intense-complex-serum-reafirmante-30ml"
  ],
  "mesoprotech-melan-130-pigment-control-50-ml": [
    "mesoestetic-melan-recovery-balamo-calmante-50ml"
  ],
  "davines-oi-champu-280-ml-y-oi-acondicionador-250-ml": [
    "oi-hair-butter-250-ml-davines",
    "davines-oi-all-in-one-milk-135ml"
  ],
  "oribe-dry-texturizing-spray-300ml": [
    "oribe-gold-lust-heat-protection-250ml"
  ],
  "qiqi-bare-repair-oil-50ml": [
    "qiqi-smooth-service-champu-300ml",
    "qiqi-hydration-fixation-conditioner-300g"
  ],
  "oi-hair-butter-250-ml-davines": [
    "davines-oi-shampoo-280ml",
    "davines-oi-conditioner-250ml"
  ],
  "davines-love-smoothing-conditioner-250-ml": [
    "davines-champu-love-smoothing-250-ml",
    "davines-love-smoothing-lightweight-milk-150ml-anti-frizz"
  ],
  "davines-love-instant-mask-disciplinante-250ml": [
    "davines-champu-love-smoothing-250-ml",
    "davines-love-smoothing-conditioner-250-ml"
  ],
  "davines-energizing-overnight-serum-100ml": [
    "davines-250ml-anticaida-energizing-champu"
  ],
  "oribe-gold-lust-repair-and-restore-conditioner-200ml": [
    "oribe-gold-lust-repair-and-restore-shampoo-250ml",
    "oribe-gold-lust-transformative-masque-150-ml"
  ],
  "oribe-gold-lust-transformative-masque-150-ml": [
    "oribe-gold-lust-repair-and-restore-shampoo-250ml",
    "oribe-gold-lust-repair-and-restore-conditioner-200ml"
  ],
  "oribe-gold-lust-dry-shampoo-300ml": [
    "oribe-gold-lust-repair-and-restore-shampoo-250ml"
  ],
  "medik8-crystal-retinal-3-30ml": [
    "medik8-total-moisture-daily-facial-cream-50ml"
  ],
  "mesoestetic-age-element-firming-cream-50ml": [
    "mesoestetic-age-element®-firming-concentrate-serum-30ml-reafirmante-concentrado"
  ],
  "lotion-p50-biologique-recherche": [
    "lait-vip-o2-biologique-recherche"
  ],
  "davines-naturaltech-replumping-shampoo-250ml": [
    "davines-naturaltech-repumpling-conditioner-150ml"
  ],
  "davines-naturaltech-repumpling-conditioner-150ml": [
    "davines-naturaltech-replumping-shampoo-250ml"
  ],
  "davines-oi-oil-aceite-restructurante-sin-aclarado-50ml": [
    "davines-oi-shampoo-280ml",
    "davines-oi-conditioner-250ml"
  ],
  "k18-damage-shield-shampoo-250ml": [
    "k18-damage-shield-protective-conditioner-250ml"
  ],
  "k18-damage-shield-protective-conditioner-250ml": [
    "k18-damage-shield-shampoo-250ml"
  ],
  "k18-molecular-repair-mascarilla-reparadora-15ml": [
    "k18-damage-shield-shampoo-250ml"
  ],
  "calecim-scalp-nourishing-shampoo-300-ml": [
    "calecim-structure-enhancing-conditioner-300-ml-acondicionador",
    "calecim-scalp-activating-mist-100-ml"
  ],
  "calecim-structure-enhancing-conditioner-300-ml-acondicionador": [
    "calecim-scalp-nourishing-shampoo-300-ml"
  ],
  "calecim-scalp-activating-mist-100-ml": [
    "calecim-scalp-nourishing-shampoo-300-ml"
  ],
  "calecim-scalp-detox-cleanser-100-ml": [
    "calecim-scalp-nourishing-shampoo-300-ml"
  ],
  "mesoestetic-melan-tran3x-concentrate-30ml": [
    "mesoprotech-melan-130-pigment-control-50-ml"
  ],
  "natura-bisse-essential-shock-intense-complex-serum-reafirmante-30ml": [
    "crema-reafirmante-natura-bisse-pro-exo-colageno-75ml"
  ],
  "oribe-serene-scalp-densifying-shampoo-250ml": [
    "oribe-serene-scalp-densifying-conditioner-175ml",
    "oribe-serene-scalp-densifying-spray-125ml"
  ],
  "oribe-serene-scalp-densifying-conditioner-175ml": [
    "oribe-serene-scalp-densifying-shampoo-250ml",
    "oribe-serene-scalp-densifying-spray-125ml"
  ],
  "oribe-serene-scalp-densifying-spray-125ml": [
    "oribe-serene-scalp-densifying-shampoo-250ml",
    "oribe-serene-scalp-densifying-conditioner-175ml"
  ],
  "oribe-serene-scalp-shampoo-250ml": [
    "oribe-serene-scalp-balancing-conditioner-200ml",
    "oribe-serene-scalp-soothing-leave-on-50ml"
  ],
  "oribe-serene-scalp-balancing-conditioner-200ml": [
    "oribe-serene-scalp-shampoo-250ml",
    "oribe-serene-scalp-soothing-leave-on-50ml"
  ],
  "oribe-serene-scalp-soothing-leave-on-50ml": [
    "oribe-serene-scalp-shampoo-250ml",
    "oribe-serene-scalp-balancing-conditioner-200ml"
  ],
  "oribe-serene-scalp-oil-control-shampoo-250ml": [
    "oribe-serene-scalp-oil-control-treatment-mist",
    "oribe-serene-scalp-oil-control-champu-seco-45g"
  ],
  "oribe-serene-scalp-oil-control-treatment-mist": [
    "oribe-serene-scalp-oil-control-shampoo-250ml",
    "oribe-serene-scalp-oil-control-champu-seco-45g"
  ],
  "oribe-serene-scalp-oil-control-champu-seco-45g": [
    "oribe-serene-scalp-oil-control-shampoo-250ml",
    "oribe-serene-scalp-oil-control-treatment-mist"
  ],
  "oribe-shampoo-for-magnificent-volume-250-ml": [
    "oribe-conditioner-for-magnificent-volume-250-ml",
    "oribe-maximista-thickening-spray-200ml"
  ],
  "oribe-bright-blonde-shampoo-for-beautiful-color-250ml": [
    "oribe-bright-blonde-conditioner-for-beautiful-color-250ml",
    "oribe-bright-blonde-radiance-repair-treatment-125ml"
  ],
  "oribe-bright-blonde-conditioner-for-beautiful-color-250ml": [
    "oribe-bright-blonde-shampoo-for-beautiful-color-250ml",
    "oribe-bright-blonde-radiance-repair-treatment-125ml"
  ],
  "oribe-bright-blonde-radiance-repair-treatment-125ml": [
    "oribe-bright-blonde-shampoo-for-beautiful-color-250ml",
    "oribe-bright-blonde-conditioner-for-beautiful-color-250ml"
  ],
  "mesoestetic-tricology-shampoo-225ml": [
    "mesoestetic-tricology-lotion-8-5-ml-locion-capilar-anticaida"
  ],
  "mesoestetic-tricology-lotion-8-5-ml-locion-capilar-anticaida": [
    "mesoestetic-tricology-shampoo-225ml"
  ],
  "davines-nounou-shampoo-champu-hidratante-250ml": [
    "davines-nounou-conditioner-acondicionador-reparador",
    "davines-nounou-oil-50ml-aceite-nutritivo-cabello-tratado"
  ],
  "davines-nounou-oil-50ml-aceite-nutritivo-cabello-tratado": [
    "davines-nounou-shampoo-champu-hidratante-250ml",
    "davines-nounou-conditioner-acondicionador-reparador"
  ],
  "davines-nounou-refill-500ml-champu-nutritivo-cabello-procesado": [
    "davines-nounou-conditioner-acondicionador-reparador",
    "davines-nounou-oil-50ml-aceite-nutritivo-cabello-tratado"
  ],
  "oribe-foundation-mist-200-ml": [
    "oribe-signature-conditioner-200ml"
  ],
  "oribe-free-styler-working-hairspray-300-ml": [
    "oribe-foundation-mist-200-ml"
  ],
  "oribe-impermeable-anti-humidity-spray-200-ml": [
    "oribe-run-through-detangling-primer-175-ml"
  ],
  "oribe-superfine-hair-spray-300-ml": [
    "oribe-foundation-mist-200-ml"
  ],
  "oribe-thick-dry-finishing-spray-250-ml": [
    "oribe-maximista-thickening-spray-200ml"
  ],
  "oribe-invisible-defense-universal-protection-spray-175-ml": [
    "oribe-run-through-detangling-primer-175-ml"
  ],
  "oribe-creme-for-style-150-ml": [
    "oribe-signature-shampoo-250ml",
    "oribe-signature-conditioner-200ml"
  ],
  "oribe-gel-serum-radiance-magic-and-hold-150-ml": [
    "oribe-foundation-mist-200-ml"
  ],
  "oribe-imperial-blowout-transformative-styling-creme-150-ml": [
    "oribe-foundation-mist-200-ml"
  ],
  "oribe-power-drops-color-preservation-booster-30-ml": [
    "oribe-shampoo-for-beautiful-color-250-ml",
    "oribe-conditioner-for-beautiful-color-200-ml"
  ],
  "oribe-power-drops-hydration-anti-pollution-booster-30-ml": [
    "oribe-gold-lust-repair-and-restore-shampoo-250ml",
    "oribe-gold-lust-repair-and-restore-conditioner-200ml"
  ],
  "straight-away-smoothing-blowout-cream-150-ml": [
    "oribe-impermeable-anti-humidity-spray-200-ml",
    "oribe-run-through-detangling-primer-175-ml"
  ],
  "oribe-tres-set-structure-spray-300-ml": [
    "oribe-foundation-mist-200-ml"
  ],
  "oribe-curl-control-silkening-creme-150ml": [
    "oribe-shampoo-moisture-control-250ml",
    "oribe-intense-conditioner-moisture-control-200ml"
  ],
  "oribe-curl-gloss-hydration-hold-175ml": [
    "oribe-shampoo-moisture-control-250ml",
    "oribe-intense-conditioner-moisture-control-200ml"
  ]
});
